import { Component } from '@angular/core';
import { MessageBaseComponent } from '../message-base/message-base.component';

@Component({
    selector: 'race-to-race',
    templateUrl: '../message-base/message-base.component.html',
    standalone: false
})
export class RaceToRaceComponent extends MessageBaseComponent {
  constructor () {
    super();
    this.channel = "Race";
  };
};
